"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moment = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
var moment = require('moment-timezone');
exports.moment = moment;
var ALREADY_PATCHED_MOMENT = '__already-patched-moment-in-bringg-common-utils__';
// This can happen as we may have multiple version of common-utils in the same project
// or can have multiple instances even on the same version - https://nodejs.org/api/modules.html#module-caching-caveats
if (!moment.prototype[ALREADY_PATCHED_MOMENT]) {
    patchToISOString();
    moment.prototype[ALREADY_PATCHED_MOMENT] = true;
}
function patchToISOString() {
    /**
     * Implementation of moment.toISOString() that is much faster by making some assumptions
     *
     * Assumptions:
     * - Date.prototype.toISOString function exists {@link https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/moment/format.js#L26|assumption}
     * - the year is between 1 and 9998 {@link https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/moment/format.js#L18-L25|assumption}
     *
     * @see Copied from toISOString() in moment.js {@link https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/moment/format.js#L12-L40 toISOString()}
     */
    var kOldToISOString = Symbol('kOldToISOString');
    moment.prototype[kOldToISOString] = moment.prototype.toISOString;
    moment.prototype.toISOString = function (keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        return keepOffset !== true
            ? /**
                 * Fast path
                 * the offset should not be included in the ISO string {@link https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/moment/format.js#L16|assumption}
                 */
                this.toDate().toISOString()
            : // Slow path
                this[kOldToISOString](keepOffset);
    };
}
//# sourceMappingURL=moment.js.map